import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface SetRunFlowTaskOutputStepsParams {
  readonly id: string;
  readonly runAllOutputs: boolean;
  readonly isRunAllIncremental: boolean;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
}

export class SetRunFlowTaskOutputStepsRequest extends Request<SetRunFlowTaskOutputStepsParams, IResult> {
  constructor(params: SetRunFlowTaskOutputStepsParams) {
    super('setRunFlowTaskOutputSteps', params);
  }
}
